/* eslint-disable new-cap */

import { reject } from 'redux-optimist-promise';
import { get } from 'lodash';
import {
  FETCH_USER_FUTURE_TRIPS_FETCHED,
  FETCH_USER_FUTURE_TRIPS,
  FETCH_USER_FUTURE_TRIPS_RESOLVED,
  RESET_USER_FUTURE_TRIPS,
} from 'Store/constants';
import createReducer from 'Store/utils/createReducer';

export const initialState = {
  data: {
    bookings: [],
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2,
};

export default createReducer(initialState, {
  [FETCH_USER_FUTURE_TRIPS_FETCHED](state, action) {
    return {
      ...state,
      data: {
        bookings: get(action, 'payload.bookings.data', []),
      },
    };
  },
  [FETCH_USER_FUTURE_TRIPS](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_USER_FUTURE_TRIPS_RESOLVED](state, action) {
    const hasNextPage = get(action, 'payload.userBookings.pageInfo.hasNextPage');
    const currentPage = get(action, 'payload.userBookings.pageInfo.currentPage');
    const fetchedTripsList = get(action, 'payload.userBookings.data', []);
    const trips = get(state, 'data.bookings').concat(fetchedTripsList);
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      data: {
        bookings: trips,
      },
      hasNextPage,
      currentPage,
      nextPage: currentPage + 1,
    };
  },
  [reject(FETCH_USER_FUTURE_TRIPS)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: false,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
  [RESET_USER_FUTURE_TRIPS]() {
    return initialState;
  },
});
